import React from 'react';

const PharmacyListItem = ({ item }: { item: Record<string, any> }): JSX.Element => {
    return (
        <div className="component-pharmacy-list-item">
            <p>{item.name}</p>
        </div>
    );
};

export default PharmacyListItem;
